module.exports = __webpack_public_path__ + "static/img/314b4286.c10.6459939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/314b4286.c10.jpg
// module id = UkEA
// module chunks = 2